import { D, fiscalDate } from '@makila/fiscal';
/**
 * Entradas e bilhetes (bar, discoteca; docs/14 Fase 2). A entrada é um artigo
 * normal, com IVA, que deixa entrar N pessoas. Vendida à porta, conta logo;
 * com bilhete (venda antecipada), sai um código com QR por unidade e conta
 * quando o bilhete é lido à porta. Os convidados entram sem venda.
 */
/** A noite começa às 06:00 de Maputo: o que entra às 02:00 de sábado conta para sexta. */
export const NIGHT_STARTS_HOUR = 6;
export function nightOf(at = new Date()) {
    return fiscalDate(new Date(at.getTime() - NIGHT_STARTS_HOUR * 3_600_000));
}
export const TICKET_RE = /^[A-Z2-9]{4}-[A-Z2-9]{4}$/;
/** O leitor de QR (ou quem escreve) pode trazer minúsculas, espaços ou faltar o hífen. */
export function normalizeTicketCode(raw) {
    const c = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (c.length !== 8)
        return null;
    const code = `${c.slice(0, 4)}-${c.slice(4)}`;
    return TICKET_RE.test(code) ? code : null;
}
/** Pode entrar com este bilhete? (já lido nesta caixa conta como usado) */
export function ticketCheck(t, now = new Date(), usedHere = new Set()) {
    if (!t)
        return { ok: false, reason: 'Bilhete desconhecido' };
    if (t.void)
        return { ok: false, reason: 'Bilhete anulado (devolvido)' };
    if (t.used || usedHere.has(t.code))
        return { ok: false, reason: 'Este bilhete já entrou' };
    if (t.eventDate && t.eventDate !== nightOf(now))
        return { ok: false, reason: `Bilhete para a noite de ${t.eventDate.split('-').reverse().join('/')}` };
    return { ok: true, reason: null };
}
/** Linhas de bilhete: a quantidade tem de ser inteira (um código por unidade). */
export function ticketLines(lines) {
    return lines.flatMap((l, index) => {
        if (!l.ticket || !l.admits)
            return [];
        const q = new D(l.quantity);
        if (!q.isInteger() || q.lessThan(1) || q.greaterThan(200))
            throw new RangeError(`"${l.description}": os bilhetes vendem-se à unidade (1 a 200)`);
        return [{ index, count: q.toNumber(), admits: l.admits, eventDate: l.eventDate ?? null }];
    });
}
/** Pessoas que uma linha deixa entrar já (venda à porta); os bilhetes contam quando são lidos. */
export const linePeople = (l) => (l.admits && !l.ticket ? new D(l.quantity).times(l.admits).toNumber() : 0);
/**
 * Pessoas desta noite que a caixa ainda não mandou para a nuvem: somam-se ao
 * contador que a nuvem devolveu (que já tem as outras caixas).
 */
export function pendingDoorPeople(events, night) {
    let n = 0;
    for (const e of events) {
        const at = new Date(e.occurredAt);
        if (nightOf(at) !== night)
            continue;
        if (e.type === 'ticket.used')
            n += Number(e.payload.admits ?? 0);
        else if (e.type === 'door.guest')
            n += Number(e.payload.people ?? 0);
        else if (e.type === 'document.issued') {
            const d = e.payload;
            if (!['VD', 'FR', 'FT'].includes(d.docType))
                continue;
            for (const l of d.lines)
                n += linePeople(l);
        }
    }
    return n;
}
/** Bilhetes vendidos nesta caixa que ainda não voltaram no catálogo: a porta da mesma caixa já os aceita. */
export function pendingTickets(events) {
    return events.flatMap((e) => {
        if (e.type !== 'document.issued')
            return [];
        const d = e.payload;
        return (d.tickets ?? []).map((t) => ({ code: t.code, name: d.lines[t.line]?.description ?? 'Bilhete', admits: t.admits, eventDate: t.eventDate, used: false, void: false }));
    });
}
//# sourceMappingURL=door.js.map